import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import api from "../api/axios";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";

const Inquiry = () => {
  const [profiles, setProfile] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState([]);
  const [filterText, setFilterText] = useState("");
  const history = useHistory();

  const fetchInquiry = async () => {
    try {
      const response = await api.post(`/inquiry/get`);
      if (response.data.success) {
        setProfile(response.data.Profile);
      } else {
        setError("Inquiry not found");
      }
    } catch (err) {
      setError("Error fetching Inquiry details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInquiry();
  }, []);

  const filteredItems = profiles.filter((item) => {
    const text = filterText.toLowerCase();
    const company_name = String(item.company_name || "").toLowerCase();
    const name = String(item.name || "").toLowerCase();
    const address = String(item.address || "").toLowerCase();
    // const city = String(item.city || "").toLowerCase();
    const phone = String(item.phone || "").toLowerCase();
    const email = String(item.email || "").toLowerCase();
    // const zip_code = String(item.zip_code || "").toLowerCase();
    // const fax = String(item.fax || "").toLowerCase();
    const website = String(item.website || "").toLowerCase();
    const comments = String(item.comments || "").toLowerCase();

    return (
      company_name.includes(text) ||
      name.includes(text) ||
      address.includes(text) ||
      // city.includes(text) ||
      phone.includes(text) ||
      email.includes(text) ||
      // zip_code.includes(text) ||
      // fax.includes(text) ||
      website.includes(text) ||
      comments.includes(text)
    );
  });

  const deleteInquiry = async (e, id) => {
    e.preventDefault();
    try {
      const response = await api.post(`/profile/delete/${id}`);
      if (response) {
        fetchInquiry();
        toast.success("profile Delete Success");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      name: "Id",
      selector: (row) => row.id,
      sortable: true,
      width: "100px",
    },
    {
      name: "Company Name",
      selector: (row) => row.company_name,
      sortable: true,
      width: "150px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      width: "150px",
    },
    {
      name: "Address",
      selector: (row) => row.address,
      sortable: true,
      width: "200px",
    },
    // {
    //   name: "City",
    //   selector: (row) => row.city,
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Phone",
      selector: (row) => row.phone,
      sortable: true,
      width: "150px",
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      width: "200px",
    },
    // {
    //   name: "Zip Code",
    //   selector: (row) => row.zip_code,
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Fax",
    //   selector: (row) => row.fax,
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Website",
      selector: (row) => row.website,
      sortable: true,
      width: "150px",
    },
    {
      name: "Message",
      selector: (row) => row.comments,
      sortable: true,
      width: "200px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex gap-2">
          <button
            className="btn btn-lg"
            onClick={(e) => deleteInquiry(e, row.id)}
          >
            <i className="icon-trash-2"></i>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];
  return (
    <>
      <div className="main-content-inner">
        {/* <!-- main-content-wrap --> */}
        <div className="main-content-wrap">
          <div className="flex items-center flex-wrap justify-between gap20 mb-27">
            <h3>Inquiry List</h3>
            <ul className="breadcrumbs flex items-center flex-wrap justify-start gap10">
              <li>
                <Link to="/dashboard">
                  <div className="text-tiny">Dashboard</div>
                </Link>
              </li>
              <li>
                <i className="icon-chevron-right"></i>
              </li>
              <li>
                <div className="text-tiny">Product Categories List</div>
              </li>
            </ul>
          </div>
          {/* <!-- product-list --> */}
          <div className="wg-box">
            {error && <p className="text-danger">{error}</p>}

            {/* Search Input */}
            <div className="datatable-container">
              <div className="datatable-header">
                <input
                  type="text"
                  placeholder="Search product..."
                  className="datatable-search"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
                {filterText && (
                  <button
                    className="datatable-clear"
                    onClick={() => setFilterText("")}
                  >
                    ✕
                  </button>
                )}
              </div>
              <DataTable
                columns={columns}
                data={filteredItems}
                progressPending={loading}
                pagination
                highlightOnHover
                striped
                responsive
                defaultSortField="name"
              />
              <div className="divider"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Inquiry;
